import { ClippingStudioMamItem } from "./clipping-studio-mam-item";

/** One fill-loop batch of video items for the Clipping Studio Media panel. */
export interface ClippingStudioMamMediaPage {
  items: ClippingStudioMamItem[];
  /** Next GetMediaList Offset (raw API cursor, not filtered count). */
  nextOffset: number;
  /** True when further API pages will not yield more rows. */
  exhausted: boolean;
}

/**
 * Provides MAM items for the Clipping Studio left sidebar panels.
 * Same data flow as Scheduler/Live Studio: Graphics from Graphic API, Media from GetMediaList.
 */
export abstract class IClippingStudioMamCatalogService {
  /**
   * Returns MAM items for the Graphics panel: static images first, then GFX.
   * Loads both sources (media images + Graphic API) and returns only when all are loaded,
   * so the UI can show the list after full load. Filter (All / Images / GFX) is applied in the UI.
   */
  abstract getMamItemsForGraphics(
    searchQuery: string,
  ): Promise<ClippingStudioMamItem[]>;

  /**
   * Returns a page of video items for the Media panel (AudioVideo / Video only).
   * Fetches GetMediaList pages in a fill-loop until at least minVideoCount videos
   * are collected or the API is exhausted.
   */
  abstract getMamItemsForMedia(
    searchQuery: string,
    tagIds?: number[],
    languageCodes?: string[],
    apiOffset?: number,
    minVideoCount?: number,
  ): Promise<ClippingStudioMamMediaPage>;
}
